<template>
  <div class="list_index">
    <div class="info">
      <el-row>
        <el-col :span="6">客户信息：{{ customer }}</el-col>
        <el-col :span="6">项目编号：{{ item_no }}</el-col>
        <el-col :span="6">机组编号：{{ geteway_name }}</el-col>
        <el-col :span="6">机型：{{ equipmentModel }}</el-col>
        <el-col :span="6"
          >待机时间：{{ deviceData.standby_day }} 天
          {{ deviceData.standby_hour }} 小时</el-col
        >
        <el-col :span="6"
          >运行时间：{{ deviceData.operation_day }} 天
          {{ deviceData.operation_hour }} 小时</el-col
        >
        <el-col :span="6"
          >启停次数：{{ deviceData.startAndStop }} 次<span
            class="record"
            @click="getRecordData('启停记录')"
            >(记录)</span
          ></el-col
        >
        <el-col :span="6"
          >保养剩余时间：{{
            deviceData.remainingTimeOfMaintenance
          }}
          小时</el-col
        >
        <el-col :span="6"
          >机组状态：{{
            deviceData.unitStatus == "1" ? "运行" : "停止"
          }}</el-col
        >
        <el-col :span="6">报警故障：{{ deviceData.alarmFault }}</el-col>
        <el-col :span="6"
          >机组检修信息：
          <span
            :class="deviceData.unitMaintenanceInformation != '0' ? 'alert' : ''"
          >
            {{
              deviceData.unitMaintenanceInformation == "0"
                ? "无异常"
                : deviceData.unitMaintenanceInformation == "1"
                ? "更换机组润滑油!"
                : deviceData.unitMaintenanceInformation == "2"
                ? "更换机组叶轮!"
                : deviceData.unitMaintenanceInformation == "3"
                ? "更换机组齿轮箱轴承!"
                : deviceData.unitMaintenanceInformation == "4"
                ? "更换主电机驱动端轴承!"
                : deviceData.unitMaintenanceInformation == "5"
                ? "更换主电机非驱动端轴承!"
                : deviceData.unitMaintenanceInformation == "6"
                ? "更换导叶阀!"
                : deviceData.unitMaintenanceInformation == "7"
                ? "更换放空阀!"
                : ""
            }}
          </span>
          <span class="record" @click="getRecordData('检修')">(记录)</span>
        </el-col>
        <el-col :span="6"
          >维护保养信息：
          <span
            :class="deviceData.maintenanceInformation != '0' ? 'alert' : ''"
          >
            {{
              deviceData.maintenanceInformation == "0"
                ? "无异常"
                : deviceData.maintenanceInformation == "1"
                ? "清洗油冷却器!"
                : deviceData.maintenanceInformation == "2"
                ? "检测润滑油!"
                : deviceData.maintenanceInformation == "3"
                ? "切换滤芯!"
                : deviceData.maintenanceInformation == "4"
                ? "更换滤芯!"
                : deviceData.maintenanceInformation == "5"
                ? "清理油雾风机!"
                : deviceData.maintenanceInformation == "6"
                ? "检测主电机轴承温度!"
                : ""
            }} </span
          ><span class="record" @click="getRecordData('保养')">(记录)</span>
        </el-col>
      </el-row>
    </div>
    <!-- <p class="text">{{tableData[0][0].ts}}</p> -->
    <div class="main">
      <div class="list" v-for="(item, index) in titles" :key="index">
        <p class="title">{{ item }}</p>
        <el-row>
          <el-col
            class="items"
            :span="4"
            v-for="(items, indexs) in tableData[index]"
            :key="indexs"
          >
            <el-row>
              <el-col class="item" :span="14">{{
                items.alias ? items.alias : items.name
              }}</el-col>
              <el-col class="item" :span="10"
                ><span class="bold_data">{{ items.data }}</span>
                {{ items.unitOrDescription }}</el-col
              >
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog title="启停记录" :visible.sync="showSwitchData" width="50%">
      <el-table stripe border :data="switch_tableData">
        <el-table-column
          label="时间"
          prop="date"
          :show-overflow-tooltip="true"
          align="center"
        ></el-table-column>
        <el-table-column
          label="操作"
          prop="describeContent"
          :show-overflow-tooltip="true"
          align="center"
        ></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          layout="total , prev, pager, next"
          :current-page="switch_page"
          :total="switch_count"
          @current-change="switchChangePage"
        ></el-pagination>
      </div>
    </el-dialog>
    <el-dialog
      title="维护保养记录"
      :visible.sync="showMaintainData"
      width="50%"
    >
      <el-table stripe border :data="maintain_tableData">
        <el-table-column
          label="保养信息"
          :show-overflow-tooltip="true"
          align="center"
        >
          <template slot-scope="scope">
            <p>
              {{
                scope.row.describeContent == "1"
                  ? "清洗油冷却器"
                  : scope.row.describeContent == "2"
                  ? "检测润滑油"
                  : scope.row.describeContent == "3"
                  ? "切换滤芯"
                  : scope.row.describeContent == "4"
                  ? "更换滤芯"
                  : scope.row.describeContent == "5"
                  ? "清理油雾风机"
                  : scope.row.describeContent == "6"
                  ? "检测主电机轴承温度"
                  : ""
              }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="时间"
          prop="date"
          :show-overflow-tooltip="true"
          align="center"
        ></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          layout="total , prev, pager, next"
          :current-page="maintain_page"
          :total="maintain_count"
          @current-change="maintainChangePage"
        ></el-pagination>
      </div>
    </el-dialog>
    <el-dialog title="机组检修记录" :visible.sync="showRepairData" width="50%">
      <el-table stripe border :data="repair_tableData">
        <el-table-column
          label="检修信息"
          :show-overflow-tooltip="true"
          align="center"
        >
          <template slot-scope="scope">
            <p>
              {{
                scope.row.describeContent == "1"
                  ? "更换机组润滑油"
                  : scope.row.describeContent == "2"
                  ? "更换机组叶轮"
                  : scope.row.describeContent == "3"
                  ? "更换机组齿轮箱轴承"
                  : scope.row.describeContent == "4"
                  ? "更换主电机驱动端轴承"
                  : scope.row.describeContent == "5"
                  ? "更换主电机非驱动端轴承"
                  : scope.row.describeContent == "6"
                  ? "更换导叶阀"
                  : scope.row.describeContent == "7"
                  ? "更换放空阀"
                  : ""
              }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="时间"
          prop="date"
          :show-overflow-tooltip="true"
          align="center"
        ></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          layout="total , prev, pager, next"
          :current-page="repair_page"
          :total="repair_count"
          @current-change="repairChangePage"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DataService from "@/api/data";
export default {
  data() {
    return {
      showSwitchData: false,
      showMaintainData: false,
      showRepairData: false,
      switch_tableData: [],
      maintain_tableData: [],
      repair_tableData: [],
      switch_page: 1,
      maintain_page: 1,
      repair_page: 1,
      switch_count: 0,
      maintain_count: 0,
      repair_count: 0,
      size: 10,
      serial_number: "",
      equipmentModel: "",
      stable: "",
      titles: [],
      tableData: [],
      geteway_name: "",
      item_no: "",
      region: "",
      customer: "",
      timer: "",
      deviceData: {},
      timeColor: "",
      Interval: 5000,
      device_rank: "",
    };
  },
  methods: {
    //获取定时器时间
    getTimer(type) {
      let _this = this;
      DataService.queryTimer({
        user_id: this.$store.state.user_id,
      })
        .then((res) => {
          this.Interval = Number(res.data) * 1000;
          if (type == "update") {
            clearInterval(this.timer);
            this.timer = setInterval(function() {
              _this.getData();
            }, this.Interval);
          }
        })
        .catch((err) => {
          this.$message.error(err.msaage);
        });
    },
    //获取设备信息
    getUnitOperationData() {
      DataService.queryUnitOperationData({
        serialNumber: this.serial_number,
        sTable: this.stable,
      })
        .then((res) => {
          this.deviceData = res.data;
        })
        .catch((err) => {
          if (err.data) {
            this.deviceData = err.data;
          }
          this.$message.error(err.message);
        });
    },
    getRecordData(type) {
      let page;
      if (type == "启停记录") {
        page = this.switch_page;
      } else if (type == "检修") {
        page = this.repair_page;
      } else if (type == "保养") {
        page = this.maintain_page;
      }
      DataService.queryEquipmentInformationEecord({
        page: page,
        size: this.size,
        serialNumber: this.serial_number,
        type: type,
      })
        .then((res) => {
          if (type == "启停记录") {
            this.switch_tableData = res.data.projectSiteList;
            this.switch_count = res.data.count;
            this.showSwitchData = true;
          } else if (type == "检修") {
            this.repair_tableData = res.data.projectSiteList;
            this.repair_count = res.data.count;
            this.showRepairData = true;
          } else if (type == "保养") {
            this.maintain_tableData = res.data.projectSiteList;
            this.maintain_count = res.data.count;
            this.showMaintainData = true;
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    //启停记录页数变化
    switchChangePage(page) {
      this.switch_page = page;
      this.getRecordData("启停记录");
    },
    //保养记录页数变化
    maintainChangePage(page) {
      this.maintain_page = page;
      this.getRecordData("保养");
    },
    //检修记录页数变化
    repairChangePage(page) {
      this.repair_page = page;
      this.getRecordData("检修");
    },
    getData() {
      DataService.realData({
        serialNumber: this.serial_number,
        equipmentModel: this.stable,
        centrifugeLevel: this.device_rank,
      })
        .then((res) => {
          if (res.data != undefined) {
            this.timeColor = "green";
            this.tableData = [];
            this.titles = Object.keys(res.data);
            Object.keys(res.data).forEach((el) => {
              if (el == "状态指示") {
                res.data[el].forEach((ele) => {
                  if (ele.alias == "启动柜就绪反馈") {
                    if (ele.data == 1) {
                      ele.data = "就绪";
                    } else {
                      ele.data = "未就绪";
                    }
                  } else {
                    if (ele.data == 1) {
                      ele.data = "运行";
                    } else {
                      ele.data = "停止";
                    }
                  }
                });
                this.tableData.push(res.data[el]);
              } else {
                this.tableData.push(res.data[el]);
              }
            });
            this.$emit("time", this.tableData[0][0].ts, this.timeColor);
          }
        })
        .catch((err) => {
          if (err.data != undefined) {
            if (this.timeColor != "red") {
              this.$message.error(err.message);
            }
            this.timeColor = "red";
            this.tableData = [];
            this.titles = Object.keys(err.data);
            Object.keys(err.data).forEach((el) => {
              this.tableData.push(err.data[el]);
            });
            this.$emit("time", this.tableData[0][0].ts, this.timeColor);
          }
        });
    },
  },
  created() {
    this.getTimer();
    if (this.$route.query.serial_number) {
      this.serial_number = this.$route.query.serial_number;
      this.equipmentModel = this.$route.query.equipmentModel;
      this.stable = this.$route.query.stable;
      this.geteway_name = this.$route.query.geteway_name;
      this.item_no = this.$route.query.item_no;
      this.region = this.$route.query.region;
      this.customer = this.$route.query.customer;
      this.device_rank = this.$route.query.device_rank;
    }
  },
  mounted() {
    let _this = this;
    this.getData();
    this.getUnitOperationData();
    setTimeout(() => {
      this.timer = setInterval(() => {
        _this.getData();
      }, this.Interval);
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.list_index {
  height: 100%;
  .info {
    color: #fff;
    font-size: 14px;
    /deep/ .el-col {
      margin: 8px 0;
    }
  }
  .main {
    .list {
      margin-top: 20px;
      .title {
        color: #fff;
        font-size: 12px;
        font-weight: 700;
        margin-bottom: 5px;
      }
    }
    /deep/ .item {
      color: #fff;
      font-size: 12px;
      border: solid 1px #00c0ff;
      line-height: 25px;
      padding-left: 10px;
    }
    /deep/ .item:nth-child(2n) {
      text-align: center;
      margin-left: none;
    }
  }
}
.items {
  border: none !important;
  padding-left: none !important;
}
.text {
  font-size: 16px;
  margin: 28px 0;
}
.record {
  cursor: pointer;
  color: #0ab3f0;
  margin-left: 10px;
}
.alert {
  color: red;
  animation-name: imageAnim;
  animation-duration: 0.5s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: ease;
  animation-play-state: running;
}
@keyframes imageAnim {
  0% {
    opacity: 1;
  }
  // 50% {opacity: 0.5;}
  100% {
    opacity: 0;
  }
}
.bold_data {
  font-weight: 600;
}
</style>
